module.exports = __webpack_public_path__ + "static/media/logo.e439f8e5.png";